/* eslint-disable max-len */
import React from 'react';

const Block: React.FC<object> = () => {

    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.07129 12C1.65457 12 1.25463 11.8418 0.959961 11.5605C0.665394 11.2793 0.5 10.8977 0.5 10.5V6.75C0.5 6.35227 0.665394 5.97074 0.959961 5.68945C1.25463 5.40818 1.65457 5.25004 2.07129 5.25V3.75C2.07129 2.7556 2.48515 1.80186 3.22168 1.09863C3.95843 0.395371 4.95808 0 6 0C6.87098 0.000129337 7.71764 0.276085 8.40625 0.785156C9.09482 1.29422 9.58669 2.00761 9.80469 2.8125C9.83045 2.90781 9.83566 3.00703 9.82129 3.10449C9.80689 3.20195 9.77304 3.29606 9.7207 3.38086C9.66832 3.46566 9.59898 3.54038 9.5166 3.59961C9.43423 3.65881 9.34006 3.70193 9.24023 3.72656C9.1403 3.75119 9.03579 3.75692 8.93359 3.74316C8.83155 3.72942 8.73333 3.69641 8.64453 3.64648C8.46499 3.54543 8.33432 3.38015 8.28223 3.1875C8.13897 2.65717 7.79802 2.19519 7.32324 1.8877C6.84837 1.5802 6.27238 1.44858 5.70312 1.51758C5.13403 1.58657 4.61069 1.85088 4.23145 2.26172C3.85217 2.67279 3.64238 3.20223 3.64258 3.75V5.25H9.92871C10.3454 5.25004 10.7454 5.40818 11.04 5.68945C11.3346 5.97074 11.5 6.35227 11.5 6.75V10.5C11.5 10.8977 11.3346 11.2793 11.04 11.5605C10.7454 11.8418 10.3454 12 9.92871 12H2.07129ZM6 10C6.55228 10 7 9.55228 7 9V8C7 7.44772 6.55228 7 6 7C5.44772 7 5 7.44772 5 8V9C5 9.55228 5.44772 10 6 10Z"
                fill="#616E6E"
            />
        </svg>
    );
};

export default Block;